module.exports = __webpack_public_path__ + "img/New-working-in-groups.408e7df2.jpg";